import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import "./style.css";

export default function Home() {
  return (
    <section>
      <Helmet>
        <title>Home Page</title>
        <meta
          name="description"
          content="View my counter app done with useReducer and Custom Hook"
        />
        <link rel="canonical" href="/" />
      </Helmet>
      <nav className="navigation">
        <ul className="nav-ul">
          <li>
            <Link className="nav-link" to="/">
              Home
            </Link>
          </li>
          <li>
            {" "}
            <Link className="nav-link" to="/useReducerComponent">
              Use Reducer
            </Link>
          </li>
          <li>
            <Link className="nav-link" to="/custom-hooks">
              Custom Hooks
            </Link>
          </li>
          <li>
            {" "}
            <Link className="nav-link" to="/TestError">
              Test Error
            </Link>
          </li>
        </ul>
      </nav>
      <div className="app">
        <center>
          <div className="home-div">
            <div>
              <h1 className="home-page-header">
                Custom Hook & UseReducer Counter App
              </h1>
              <img
                src="https://i.ibb.co/nLmsZqw/undraw-my-code-snippets-re-4adu-1.png"
                alt="My Code Snippets "
                border="0"
                className="img_tag"
              />
            </div>
          </div>
        </center>
      </div>
    </section>
  );
}
